import { render, staticRenderFns } from "./outlayCouponDetail.vue?vue&type=template&id=438c6fab&lang=pug&"
import script from "./outlayCouponDetail.vue?vue&type=script&lang=js&"
export * from "./outlayCouponDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports